import React from 'react'
import PropTypes from 'prop-types'
import { PageHeader } from 'SRC/ui'
import { connect } from 'react-redux'
import { Preloader, AdditionalPreloader } from 'SRC/ui/Preloader'
import { CookiesHelper } from 'SRC/core/cookiesHelper/CookiesHelper'
import Router from 'next/router'
import { fetchSavedFilters } from 'SRC/modules/users/Profile/actions'
import { getProfilePaginationParams } from 'SRC/modules/users/Profile/pagination/selectors'
import { SavedFiltersPagination } from 'SRC/modules/users/Profile/pagination/components'
import { getProfileLoading, getSavedFilters, getSavedFiltersLoading } from 'SRC/modules/users/Profile/selectors'
import { ProfileApi } from 'SRC/modules/users/Profile/api'
import { SavedFilterItem } from '../Item'
import { getFilterValues } from '../functions'

export class Container extends React.Component {
  constructor (props) {
    super(props)

    this.api = new ProfileApi()
    this.cookies = new CookiesHelper()
  }

  getSearchRouterObject = (filter) => {
    const parentCategorySeo = (filter.parentCategory && filter.parentCategory.seo) || null
    const categorySeo = (filter.category && filter.category.seo) || null
    const groupSeo = (filter.group && filter.group.seo) || null

    let asUrl = '/pretraga'

    if (parentCategorySeo) {
      if (categorySeo) {
        asUrl = `/${parentCategorySeo}/${categorySeo}/pretraga`
      } else if (groupSeo) {
        asUrl = `/${parentCategorySeo}/${groupSeo}/pretraga`
      } else {
        asUrl = `/${parentCategorySeo}/pretraga`
      }
    }

    const filterValues = getFilterValues(filter)

    const hrefQuery = {
      ...filterValues
    }

    if (parentCategorySeo) {
      hrefQuery.parentCategory = parentCategorySeo
      if (categorySeo) {
        hrefQuery.category = categorySeo
      }

      if (!categorySeo && groupSeo) {
        hrefQuery.category = groupSeo
      }
    }

    return {
      href: {
        pathname: '/search',
        query: hrefQuery
      },
      as: {
        pathname: asUrl,
        query: filterValues
      }
    }
  }

  search = (filterId) => {
    const { savedFilters } = this.props

    const filter = savedFilters.find(filter => filter.id === filterId)

    const {href, as} = this.getSearchRouterObject(filter)

    Router.push(href, as)
  }

  getProducts = products => {
    return <span>{products.map(product => product.model).join(', ')}</span>
  }

  removeSavedSearch = async savedSearchId => {
    const { paginationParams, fetchSavedFilters } = this.props

    const userId = this.cookies.get('userId')
    const token = this.cookies.get('token')
    if (userId && token) {
      const result = await this.api.removeSavedFilter(userId, token, savedSearchId)
      if (result.status === 'ok') {
        fetchSavedFilters(userId, token, paginationParams.currentPage, paginationParams)
      }
    }
  }

  renderFilters = () => {
    const { savedFilters } = this.props

    return <section className='sacuvane-pretrage-content' key='sacuvane-pretrage-content'>
      {savedFilters.map(filter => <SavedFilterItem filter={filter} onClick={this.search} onRemove={this.removeSavedSearch} />)}
    </section>
  }

  render () {
    const { isProfileLoading, isSavedFiltersLoading, paginationParams } = this.props

    return <React.Fragment>
      <PageHeader key='header'>Sačuvane pretrage</PageHeader>
      <header className='sacuvane-pretrage-akcije' key='sacuvane-pretrage-akcije'>
        <p>Sačuvanih pretraga [ {paginationParams.count} ]</p>
        <p>Akcije</p>
        <p>Vrijeme</p>
      </header>
      {!isSavedFiltersLoading ? this.renderFilters() : <AdditionalPreloader />}
      {isProfileLoading ? <Preloader /> : null}
      <SavedFiltersPagination />
    </React.Fragment>
  }
}

const mapStateToProps = state => ({
  isProfileLoading: getProfileLoading(state),
  isSavedFiltersLoading: getSavedFiltersLoading(state),
  savedFilters: getSavedFilters(state),
  paginationParams: getProfilePaginationParams(state)
})

Container.propTypes = {
  isProfileLoading: PropTypes.bool.isRequired,
  isSavedFiltersLoading: PropTypes.bool.isRequired,
  savedFilters: PropTypes.array.isRequired,
  paginationParams: PropTypes.shape({
    currentPage: PropTypes.number,
    count: PropTypes.number
  }).isRequired,
  fetchSavedFilters: PropTypes.func.isRequired
}

Container.defaultProps = {
  isProfileLoading: false,
  isSavedFiltersLoading: false,
  savedFilters: []
}

Container.displayName = 'SavedFiltersContainer'

export default connect(mapStateToProps, { fetchSavedFilters })(Container)
